import { datadogRum } from '@datadog/browser-rum'
import { initDatadogRum } from '@smarty-nx/debug-utils'

export const onRouteUpdate = ({ location }) => {
  datadogRum.startView(location.href)
}

export const onClientEntry = async () => {
  initDatadogRum({
    applicationId: process.env.GATSBY_DATADOG_APP_ID,
    clientToken: process.env.GATSBY_DATADOG_TOKEN,
    site: process.env.GATSBY_DATADOG_HOST,
    service: process.env.GATSBY_DATADOG_SERVICE_NAME,
    env: process.env.GATSBY_SMARTY_ENV,
    commit: process.env.GATSBY_COMMIT,
    sessionReplay: process.env.GATSBY_SMARTY_ENV !== 'localhost',
    sessionReplaySampleRate: Number(
      process.env.GATSBY_DATADOG_SESSION_REPLAY_SAMPLE_RATE
    ),
    defaultPrivacyLevel: process.env.GATSBY_DATADOG_DEFAULT_PRIVACY_LEVEL,
  })
}
